<div>
  <router-outlet></router-outlet>
  <app-responsive-helper></app-responsive-helper>
</div>
